export default __webpack_public_path__ + "static/media/gun.172fc911.svg";